export class RedirectUrlError extends Error {}
